import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Menu, X } from "lucide-react";
import { useInfo } from "@/context/InfoContext";

export const Logo = ({ testid = "header-logo" }) => (
  <Link to="/" data-testid={testid} className="flex items-center gap-3 group">
    <span className="w-10 h-10 bg-[#111111] text-white flex items-center justify-center font-serif text-lg tracking-tight transition-transform duration-300 group-hover:rotate-[-4deg]">
      P7
    </span>
    <span className="leading-none">
      <span className="block font-serif text-[15px] tracking-[0.18em] text-[#111111]">P7 BARBING</span>
      <span className="block text-[10px] tracking-[0.45em] text-zinc-500 mt-1">SALON</span>
    </span>
  </Link>
);

const anchors = [
  { href: "/#servicios", label: "Servicios", id: "servicios" },
  { href: "/#galeria", label: "Galería", id: "galeria" },
  { href: "/#horario", label: "Horario", id: "horario" },
  { href: "/#contacto", label: "Contacto", id: "contacto" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { me } = useInfo();
  const loc = useLocation();
  const linkCls = "text-sm text-zinc-600 hover:text-[#111111] transition-colors duration-200";

  const links = (
    <>
      {anchors.map((a) => (
        <a key={a.id} href={a.href} className={linkCls} data-testid={`nav-link-${a.id}`} onClick={() => setOpen(false)}>
          {a.label}
        </a>
      ))}
      <Link to="/gestionar-reserva" className={linkCls} data-testid="nav-link-manage" onClick={() => setOpen(false)}>
        Gestionar reserva
      </Link>
      <Show when="signed-in">
        <NavLink to="/mi-cuenta" className={linkCls} data-testid="nav-link-account" onClick={() => setOpen(false)}>
          Mi cuenta
        </NavLink>
        {me?.role === "admin" && (
          <NavLink to="/admin" className={linkCls} data-testid="nav-link-admin" onClick={() => setOpen(false)}>
            Panel admin
          </NavLink>
        )}
      </Show>
      <Show when="signed-out">
        <Link to="/sign-in" className={linkCls} data-testid="nav-link-signin" onClick={() => setOpen(false)}>
          Iniciar sesión
        </Link>
      </Show>
    </>
  );

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-zinc-100" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">{links}</nav>
        <div className="flex items-center gap-3">
          <Show when="signed-in">
            <UserButton />
          </Show>
          {loc.pathname !== "/reservar" && (
            <Link
              to="/reservar"
              data-testid="nav-book-appointment-button"
              className="hidden sm:inline-flex h-11 px-6 items-center bg-[#111111] text-white text-xs tracking-[0.2em] uppercase hover:bg-zinc-800 transition-colors duration-200"
            >
              Reservar cita
            </Link>
          )}
          <button
            className="lg:hidden w-11 h-11 flex items-center justify-center border border-zinc-200"
            onClick={() => setOpen(!open)}
            aria-label="Menú"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-zinc-100 bg-white px-6 py-6 flex flex-col gap-5 animate-in fade-in slide-in-from-top-2" data-testid="mobile-menu">
          {links}
          <Link to="/reservar" onClick={() => setOpen(false)} data-testid="mobile-book-button" className="h-12 flex items-center justify-center bg-[#111111] text-white text-xs tracking-[0.2em] uppercase">
            Reservar cita
          </Link>
        </div>
      )}
    </header>
  );
};
